import moment from "moment"

/**
 * @description 判断当前环境
 * @returns env
 */
export const getEnv = () => {
  const u = navigator.userAgent.toLowerCase()
  if (u.indexOf('zhxy') > -1) {
    return 'app'
  } else {
    return 'h5'
  }
}

/**
 * @description 个性化时间
 * @returns string time
 */
export const individuaTime = (time) => {
  if(moment().isSame(moment(time), 'day')) {
    const diff = (moment().diff(moment(time))) / 1000
    if(diff < 3*60) { // 三分钟内
      return '刚刚'
    } else {
      return '今天 ' + moment(time).format('HH:mm')
    }
  } else if(moment().isSame(moment(time), 'year')){
    return moment(time).format('MM-DD')
  } else {
    return moment(time).format('YYYY-MM-DD')
  }
}

/**
 * @description 判断一个字符串是否是json格式
 * @param {string} str 
 */
export const isJSON = (str) =>  {
  if (typeof str == 'string') {
    try {
      const obj = JSON.parse(str);
      if(typeof obj == 'object' && obj ){
        return true;
      }else{
        return false;
      }
    } catch(e) {
      return false;
    }
  }
  return false
}

/**
 * @description 
 * @param {string} str 
 */
export const convertToHttps = (url) => {  
  if (url.startsWith('http://')) {  
      // 简单地通过替换协议部分来将HTTP转换为HTTPS  
      return url.replace('http://', 'https://');  
  } else {  
      // 如果链接不是HTTP，则返回原始链接（或者你可以选择抛出错误或进行其他处理）  
      return url;  
  }  
}


// WEBPACK FOOTER //
// ./src/utils/tool.js